import { useEffect, useState } from 'react';

/**
 * A turma escolhida no seletor "ID da Turma" das telas do painel. Fica lembrada na aba do
 * navegador: trocar de página e voltar mantém a escolha, e ela vale para todas as telas com o
 * seletor. É conveniência de quem opera: sem storage (aba privada, bloqueio), cada tela volta
 * ao seu padrão, como antes.
 */
const CHAVE = 'fiat-arcade:adm:turma:v1';

function lembrada(): string | null {
    try {
        return sessionStorage.getItem(CHAVE);
    } catch {
        return null;
    }
}

function lembrar(turmaId: string | null) {
    try {
        if (turmaId) sessionStorage.setItem(CHAVE, turmaId);
    } catch {
        /* sem storage: a escolha vale só enquanto a tela estiver aberta */
    }
}

/** Como o `useState` da turma, mas começa pela lembrada; `inicial` (vinda da navegação) vence. */
export function useTurmaEmUso(inicial?: string | null) {
    const [turmaId, setTurmaId] = useState<string | null>(() => inicial ?? lembrada());
    useEffect(() => lembrar(turmaId), [turmaId]);
    return [turmaId, setTurmaId] as const;
}

/** A turma lembrada só vale se estiver na lista desta tela; senão, o padrão da tela. */
export function manterSeDisponivel(atual: string | null, disponiveis: string[], padrao: string | null): string | null {
    return atual && disponiveis.includes(atual) ? atual : padrao;
}
